import React, {useEffect, useState} from "react";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import homeSVG from "../../images/nav/home.svg";
import strategySVG from "../../images/nav/strategy.svg";
import okrSVG from "../../images/OKR/OKR_target.svg";
import actionSVG from "../../images/nav/actions.svg";
import projectIMG from "../../images/nav/rocket.svg";
import dashBoardsSVG from "../../images/dashboards.svg";
import EnjoyNewsSVG from "../../images/EnjoyNews.svg";
import IAcademy from "../../images/IAcademy-reverse.svg"
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../auth/actions/authAction";
import ThumbnailCurrentUser from "../account/ThumbnailCurrentUser";
import hamMenu from "../../images/menu-mobile.svg";
import closeMenu from "../../images/close-menu-mobile.svg";
import styled, {css} from "styled-components";
import {
  ACTIONS_ROUTE,
  DASHBOARD_ABSOLUTE_ROUTE,
  ENJOY_NEWS_ROUTE,
  EYBLEARNING_ROUTE,
  HOME_ROUTE,
  MY_ACCOUNT,
  OKR_ROUTE,
  PITCH_STRATEGY_ROUTE,
  STRATEGY_ABSOLUTE_ROUTE,
  TAGS_ROUTE,
  USERS_ROUTE,
} from "../../routes/routesName";
import {IS_HEAD, ROLE_AMBASSADOR, ROLE_CODIR, ROLE_ENJOY,} from "../../permissions/roleTypes";
import Help from "./Help";
import {getImage} from "../../utils/utils";
import EnjoyNews from "../enjoyNews/EnjoyNews";
import EnjoyNewsModal from "../modal/EnjoyNewsModal";

const Nav = ({ navIsOpen, setNavIsOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { image } = useSelector((state) => state.strategy);
  useEffect(() => {
    if (!navIsOpen) {
      const app = document.getElementsByClassName("App")[0];
      app.style.height = "100%";
      app.style.overflow = "unset";
    }
  }, [navIsOpen]);

  const currentUser = useSelector((state) => state.currentUser);
  const strategy = useSelector((state) => state.strategy);
  const [openEnjoyModal, setOpenEnjoyModal] = useState(false);
  const logoutUser = () => {
    dispatch(logout());
    navigate("/");
  };

  const setNav = (openNav) => {
    setNavIsOpen(!openNav);
    const app = document.getElementsByClassName("App")[0];
    if (openNav) {
      app.style.height = "auto";
      app.style.overflow = "scroll";
    } else {
      app.style.height = "100vh";
      app.style.overflow = "hidden";
    }
  };

  const displayHelpComponent = () => {
    if (
      location.pathname === HOME_ROUTE ||
      location.pathname === STRATEGY_ABSOLUTE_ROUTE ||
      location.pathname === ACTIONS_ROUTE ||
      location.pathname === OKR_ROUTE
    ) {
      return <Help />;
    }
  };
  const openModal = () => {
    setNavIsOpen(false)
    setOpenEnjoyModal(true)
  }


  return (
    <NavBar>
      {/*Link to HOME ROUTE */}
      <HomeDiv>
        <HomeLink $mode={!!image} to={HOME_ROUTE}>
          <HomeImg
            $mode={!!image}
            className="svg-nav-bar img-home-link"
            src={getImage(image, homeSVG)}
            alt="home"
          />
          <p className={!!image ? " display-none" : "p-home"}> Accueil </p>
        </HomeLink>
      </HomeDiv>

      {/* ALL THE RIGHT ICONS IN NAV BAR : REMAIN IN MOBILE */}
      <NavBarRight>
        {/* THUMBNAIL CURRENT USER ACCOUNT*/}
        <NavLink
          to={MY_ACCOUNT}
          state={{ background: location }}
          className={"nav-link-thumbnail"}
          // activeclassName=" selected-grey"
        >
          <ThumbnailCurrentUser />
        </NavLink>
        {displayHelpComponent()}

        {/*SETTINGS*/}
        <NavIcon
          to={
            currentUser.roles.includes(ROLE_CODIR) ||
            currentUser.roles.includes(ROLE_AMBASSADOR) ||
            currentUser.roles.includes(ROLE_ENJOY)
              ? TAGS_ROUTE
              : USERS_ROUTE
          }
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#4909AA" />
            <path
              d="M18.1707 12C18.1707 11.816 18.1625 11.64 18.1461 11.456L19.6764 10.328C20.0055 10.088 20.096 9.64 19.8903 9.288L18.3518 6.704C18.1461 6.352 17.7018 6.208 17.3233 6.368L15.5543 7.096C15.2499 6.888 14.929 6.704 14.5917 6.552L14.3531 4.704C14.3037 4.304 13.95 4 13.5386 4H10.4697C10.05 4 9.69626 4.304 9.64689 4.704L9.40829 6.552C9.07095 6.704 8.75007 6.888 8.44565 7.096L6.6767 6.368C6.29823 6.208 5.85394 6.352 5.64825 6.704L4.10967 9.296C3.90398 9.648 3.99449 10.088 4.32359 10.336L5.85394 11.464C5.83748 11.64 5.82925 11.816 5.82925 12C5.82925 12.184 5.83748 12.36 5.85394 12.544L4.32359 13.672C3.99449 13.912 3.90398 14.36 4.10967 14.712L5.64825 17.296C5.85394 17.648 6.29823 17.792 6.6767 17.632L8.44565 16.904C8.75007 17.112 9.07095 17.296 9.40829 17.448L9.64689 19.296C9.69626 19.696 10.05 20 10.4614 20H13.5303C13.9417 20 14.2955 19.696 14.3449 19.296L14.5835 17.448C14.9208 17.296 15.2417 17.112 15.5461 16.904L17.3151 17.632C17.6935 17.792 18.1378 17.648 18.3435 17.296L19.8821 14.712C20.0878 14.36 19.9973 13.92 19.6682 13.672L18.1378 12.544C18.1625 12.36 18.1707 12.184 18.1707 12ZM12.0329 14.8C10.445 14.8 9.15323 13.544 9.15323 12C9.15323 10.456 10.445 9.2 12.0329 9.2C13.6209 9.2 14.9126 10.456 14.9126 12C14.9126 13.544 13.6209 14.8 12.0329 14.8Z"
              fill="#FAFAFA"
            />
          </svg>
          <p>Paramétrage</p>
        </NavIcon>

        {/*LINK FOR LOGOUT  */}
        <NavIcon to={HOME_ROUTE} onClick={logoutUser} title={"déconnexion"}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#4909AA" />
            <path
              d="M6.55556 6.55556H11.2222C11.65 6.55556 12 6.20556 12 5.77778C12 5.35 11.65 5 11.2222 5H6.55556C5.7 5 5 5.7 5 6.55556V17.4444C5 18.3 5.7 19 6.55556 19H11.2222C11.65 19 12 18.65 12 18.2222C12 17.7944 11.65 17.4444 11.2222 17.4444H6.55556V6.55556Z"
              fill="white"
            />
            <path
              d="M18.7279 11.7278L16.5579 9.5578C16.309 9.30891 15.889 9.48002 15.889 9.83002V11.2222H10.4445C10.0167 11.2222 9.66675 11.5722 9.66675 12C9.66675 12.4278 10.0167 12.7778 10.4445 12.7778H15.889V14.17C15.889 14.52 16.309 14.6911 16.5501 14.4422L18.7201 12.2722C18.8756 12.1245 18.8756 11.8756 18.7279 11.7278Z"
              fill="white"
            />
          </svg>
          <p>Déconnexion</p>
        </NavIcon>
      </NavBarRight>

      <div onClick={() => setNav(navIsOpen)} className="nav-icon">
        {navIsOpen ? (
          <img src={closeMenu} alt={"fermer le menu"} />
        ) : (
          <img src={hamMenu} alt={"ouvrir le menu"} />
        )}
      </div>

      {/*The four main icons */}
      <ul className={`nav-links ${navIsOpen ? "nav-active" : ""}`}>
        {/*Link to OKRS */}
        <li className="nav-item">
          <NavLink
            to={OKR_ROUTE}
            className={`nav-link ${
              location.pathname.includes(OKR_ROUTE) ? "selected-grey w-100" : ""
            }`}
            onClick={() => setNavIsOpen(false)}
          >
            <img src={okrSVG} alt="les objectifs de l'entreprise" />
            <p> OKRs </p>
          </NavLink>
        </li>
        {/*Link to Actions */}
        <li className="nav-item">
          <NavLink
            to={ACTIONS_ROUTE}
            className={`nav-link ${
              location.pathname.includes(ACTIONS_ROUTE)
                ? "selected-grey w-100"
                : ""
            }`}
            onClick={() => setNavIsOpen(false)}
          >
            <img src={actionSVG} alt="les paramètres de l'entreprise" />
            <p> Actions </p>
          </NavLink>
        </li>
        {/*Link to Projects */}
        <li className="nav-item">
          <NavLink
            exact={"true"}
            to={HOME_ROUTE}
            className={`nav-link ${
              location.pathname === HOME_ROUTE ? "selected-grey w-100" : ""
            }`}
            onClick={() => setNavIsOpen(false)}
          >
            <img src={projectIMG} alt="tous les projets de l'entreprise" />
            <p> Projets </p>
          </NavLink>
        </li>
        {/*Link to strategy */}
        <li className="nav-item">
          <NavLink
            to={STRATEGY_ABSOLUTE_ROUTE}
            className={`nav-link ${
              location.pathname.includes(STRATEGY_ABSOLUTE_ROUTE)
                ? "selected-grey w-100"
                : ""
            }`}
            onClick={() => setNavIsOpen(false)}
          >
            <img src={strategySVG} alt="la stratégie de l'entreprise" />
            <p> Stratégie </p>
          </NavLink>
        </li>
        {
          IS_HEAD(currentUser.roles) && (
              <>
                <Separator>

                </Separator>
                <li className="nav-item">
                  <NavLink to={DASHBOARD_ABSOLUTE_ROUTE + "/" + PITCH_STRATEGY_ROUTE} onClick={() => setNavIsOpen(false)} className={`nav-link ${
                      location.pathname.includes(DASHBOARD_ABSOLUTE_ROUTE + "/" + PITCH_STRATEGY_ROUTE)
                          ? "selected-grey w-100"
                          : ""
                  }`}>
                    <img src={dashBoardsSVG} alt="Dashboard"/>
                    <p>Dashboard</p>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <EnjoyNewsButton onClick={openModal} className="nav-link">
                    <img src={EnjoyNewsSVG} alt="EnjoyNews"/>
                    <p> EnjoyNews </p>
                  </EnjoyNewsButton>
                </li>
              </>
            )
        }

          {strategy.useLearning &&
              <>
                <Separator>

                </Separator>
                <li className="nav-item">
                  <NavLink to={EYBLEARNING_ROUTE} onClick={() => setNavIsOpen(false)} className={`nav-link ${
                      location.pathname.includes(EYBLEARNING_ROUTE)
                          ? "selected-grey w-100"
                          : ""
                  }`}>
                    <img src={IAcademy} alt="EYB Academy"/>
                    <p style={{whiteSpace: "nowrap"}}>IAcademy</p>
                  </NavLink>

                </li>
              </>
          }
            </ul>
          {
            openEnjoyModal &&
          <EnjoyNewsModal setOpen={setOpenEnjoyModal}/>
      }
    </NavBar>
  );
};

const NavIcon = styled(NavLink)`
  display: flex;
  flex-direction: column;
  &:hover {
    circle {
      fill: var(--color-purple-lighten);
    }

    path {
      fill: var(--color-purple);
    }
  }
`;
const Separator = styled.div`
  height: 50px;
  width: 1px;
  margin: 0px 5px;
  background-color: var(--color-purple);

  @media screen and (max-width: 1250px){
    display: none;
  }
`
const NavbarSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  
  @media screen and (max-width: 1250px){
    flex-direction: column;
    gap: 5px;
  }
`
const NavBarRight = styled.div`
  display: flex;
  order: 0;
  width: 40%;
  justify-content: space-evenly;
  gap: 0.5rem;

  a {
    display: flex;
    align-items: center;
  }

  img {
    cursor: pointer;
  }

  @media (min-width: 1250px) {
    width: initial;
    align-items: center;
    justify-content: center;
    order: 3;
  }
`;
const NavBar = styled.nav`
  height: 5rem;
  width: 100%;
  color: var(--color-white);
  display: grid;
  grid-template-columns: 25% 50% 25%;
  //padding: 1rem;
  margin-top: 0.5rem;

  p,
  li {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--color-black);
    text-align: center;
  }

  img:not(.img-home-link, .img-enjoy-news),
  svg {
    width: 2rem;
    height: 2rem;
  }

  .nav-connexion {
    background: #ebeff3;
  }

  .nav-link,
  .nav-link-thumbnail {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    background-color: transparent;
    transition-property: background-color;
    transition-duration: 1s;
    gap: 0.5em;
    width: 100%;

    &:hover {
      background-color: var(--color-purple-lighten);
    }

    .user-thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        font-size: 0.8em;
        margin-left: 0.5em;
        margin-right: 0.5em;
        font-weight: 700;
      }

      .current-picture {
        width: 2.5em;
        height: 2.5em;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }

  .nav-link {
    padding: 0.5em;
    min-width: 5rem;
    flex-direction: column;
    justify-content: space-between;
  }

  .nav-links {
    display: flex;
    justify-content: center;
    list-style: none;
    gap: 0.5em;
    width: 100%;
  }

  .nav-icon {
    display: none;
    font-size: 4rem;
    cursor: pointer;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 1250px) {
    display: flex;
    align-items: center;
    position: relative;
    height: 45px;
    gap: 1rem;
    justify-content: space-around;
    .p-home {
      display: none;
    }

    .nav-link {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    .home-link {
      flex-direction: column;
      padding-left: 0;

      img {
        width: 4rem;
        height: 4rem;
      }
    }

    .nav-links {
      display: flex;
      flex-direction: column;
      position: absolute;
      justify-content: flex-start;
      top: 0;
      left: 0;
      width: 20rem;
      height: 100vh;
      box-shadow: 2px 2px 50px #cccccc;
      transform: translateX(-100%);
      transition: 0.5s all;
      grid-gap: 5px;
      opacity: 0;
    }

    .nav-links.nav-active {
      z-index: 1;
      background: white;
      height: 100vh;
      transform: translateX(0%);
      opacity: 1;
    }

    ul {
      padding: 1rem;
    }

    .nav-item {
      display: flex;
      height: 40px;
      width: 100%;
      align-items: flex-start;

      .nav-link {
        padding: 0 0 0 0.5em;

        p {
          font-size: 0.9em;
          font-weight: 700;
        }

        img {
          margin-right: 1em;
        }
      }
    }

    .nav-icon {
      display: flex;
      flex-direction: row;
    }
    @media print {
      display: none;
    }
  }
`;
const HomeDiv = styled.div`
  display: flex;
  flex-direction: row !important;
  justify-content: flex-start;
`;

const HomeImg = styled.img`
  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          max-width: 5rem;
          border-radius: 5px;
          object-fit: contain;
          padding-left: 1rem;

          &:hover {
            transform: scale(1.1);
          }

          @media (min-width: 700px) {
            height: 5rem;
            max-width: 14rem;
            padding-bottom: 1rem;
          }
        `;
      default:
        return css`
          height: 2rem;
          width: 2rem;
        `;
    }
  }}
`;

const HomeLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  ${(props) => {
    switch (props.$mode) {
      case true:
        return css``;
      default:
        return css`
          transition-duration: 1s;
          border-radius: 15px;
          width: 40%;
          gap: 0.3rem;
          background-color: transparent;
          transition-property: background-color;

          &:hover {
            background-color: var(--color-purple-lighten);
          }
        `;
    }
  }}
`;
const EnjoyNewsButton = styled.a`
  cursor: pointer;
`

export default Nav;
